import { type TopPlayTargetingNode } from '@bbkAdminUtils/api-client/rest-routing-api';

/**
 * Structurally compares two play targeting nodes, ignoring fields that are
 * non-semantic (e.g. randomly generated `name` suffixes on routing nodes).
 */
export const areTargetingNodesEqual = (
  obj1: TopPlayTargetingNode | undefined,
  obj2: TopPlayTargetingNode | undefined,
  skipFields = ['name']
): boolean => {
  if (obj1 === undefined || obj2 === undefined) return true;

  const structureCompare = (value1: unknown, value2: unknown): boolean => {
    if (Array.isArray(value1) && Array.isArray(value2)) {
      if (value1.length !== value2.length) return false;
      return value1.every((item, index) =>
        structureCompare(item, value2[index])
      );
    }

    if (
      typeof value1 === 'object' &&
      value1 !== null &&
      typeof value2 === 'object' &&
      value2 !== null &&
      !Array.isArray(value1) &&
      !Array.isArray(value2)
    ) {
      const allKeys1 = Object.keys(value1);
      const allKeys2 = Object.keys(value2);

      const keys1 = allKeys1.filter((k) => !skipFields.includes(k));
      const keys2 = allKeys2.filter((k) => !skipFields.includes(k));

      const hasSameKeys =
        keys1.every((k) => allKeys2.includes(k)) &&
        keys2.every((k) => allKeys1.includes(k));

      if (!hasSameKeys) return false;

      return keys1.every((key) => {
        const val1 = (value1 as Record<string, unknown>)[key];
        const val2 = (value2 as Record<string, unknown>)[key];
        return structureCompare(val1, val2);
      });
    }

    return value1 === value2;
  };

  return structureCompare(obj1, obj2);
};
